import React, {useEffect, useState} from "react";
import { useNavigate,Link } from "react-router-dom";
import { login, forgotPassword } from "../../services/api";
import imageAside from "../../images/form-aside.png";
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import Loader from '../../images/loader.png';
import Header from "../common/Header";


const Login=()=>{
	const navigate = useNavigate();
	const [isloader , setIsLoader] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [showForgotPassword, setShowForgotPassword] = useState(false);
	const [forgotPasswordData, setForgotPasswordData] = useState({ email: "" });
	const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);
	const [forgotPasswordMessage, setForgotPasswordMessage] = useState("");
	const [forgotPasswordError, setForgotPasswordError] = useState("");
	useEffect(() => {
	  const isAuthenticated = sessionStorage.getItem('token');
	  // If token exists, redirect to /courses
	  if (isAuthenticated) {
		navigate('/course/home');
	  }
	}, []);
	const [formData, setFormData] = useState({
		email: '',
		password: ''
	  });
	const [errors, setErrors] = useState({});
  	const [successMessage, setSuccessMessage] = useState('');
	  const handleChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData({
		  ...formData,
		  [name]: type === 'checkbox' ? checked : value
		});
	  };
	  const validate = () => {
		let errors = {};
		if (!formData.email) {
		  errors.email = 'Email is required';
		} else if (!/\S+@\S+\.\S+/.test(formData.email)) {
		  errors.email = 'Email address is invalid';
		}
		if (!formData.password) {
		  errors.password = 'Password is required';
		} else if (formData.password.length < 6) {
		  errors.password = 'Password must be at least 6 characters';
		}
		setErrors(errors);
	
		return Object.keys(errors).length === 0;
	  };
	  const handleSubmit = async (e) => {
		e.preventDefault();
		if (validate()) {
		  try {
			setIsLoader(true);
			setIsSubmitting(true);
			const response = await login(formData);
			if(response.data.token){
				setSuccessMessage('Login successful!');
				sessionStorage.setItem('token', response.data.token);
				sessionStorage.setItem('user_id', response.data.user.id);
				sessionStorage.setItem('user_name', response.data.user.first_name);
				sessionStorage.setItem('user_email', response.data.user.email);
				sessionStorage.setItem('user',JSON.stringify(response.data.user));
			setIsLoader(false);
				navigate('/course/home');
			}
			else{
				setIsLoader(false);
				setErrors({ apiError: response.data.error });
			}
		
		  } catch (error) {
			setIsLoader(false);
			console.error('Error during registration:', error);
			setErrors({ apiError: error.response.data.error });
		  } finally {
			setIsSubmitting(false);
		  }
		}
	  };

	  const responseMessage = async(response) => {
		const decodedToken = jwtDecode(response.credential);
		if(decodedToken){
		   const formData = new FormData(); 			
		   formData.append('email',decodedToken.email);
		   formData.append('sub',decodedToken.sub);
		   formData.append('name',decodedToken.name);
		   console.log(formData);
		//    const response = await googleLogin(formData);
		//    if(response.data.token){
		// 	   setSuccessMessage('Login successful!');
		// 	   sessionStorage.setItem('token', response.data.token);
		// 	   sessionStorage.setItem('user_id', response.data.user.id);
		// 	   sessionStorage.setItem('user_name', response.data.user.name);
		// 	   sessionStorage.setItem('user_email', response.data.user.email);
			   
		// 	   const redirectPath = sessionStorage.getItem('redirectPath') || '/';
		// 	   sessionStorage.removeItem('redirectPath');
		// 	   navigate(redirectPath);
		//    }
		//    else{
		// 	   setErrors({ apiError: response.data.error });
		//    }
		}
   };
	  const errorMessage = (error) => {
	   console.log(error);
   };

   // Forgot Password Handlers
   const handleForgotPassword = async (e) => {
     e?.preventDefault?.();
     setForgotPasswordLoading(true);
     setForgotPasswordMessage("");
     setForgotPasswordError("");

     try {
       const userId = sessionStorage.getItem("user_id");
       const payload = userId
         ? { ...forgotPasswordData, user_id: userId }
         : { ...forgotPasswordData };
       const response = await forgotPassword(payload);
       if (response.data.status === "success") {
         setForgotPasswordMessage(response.data.message);
         setForgotPasswordData({ email: "" });
       } else {
         setForgotPasswordError(response.data.message || "An error occurred");
       }
     } catch (error) {
       if (error.response?.data?.message) {
         setForgotPasswordError(error.response.data.message);
       } else {
         setForgotPasswordError(
           "An error occurred while sending the password reset link. Please try again later."
         );
       }
     } finally {
       setForgotPasswordLoading(false);
     }
   };

   const handleForgotPasswordInputChange = (e) => {
     const { name, value } = e.target;
     setForgotPasswordData((prev) => ({ ...prev, [name]: value }));
     if (forgotPasswordMessage || forgotPasswordError) {
       setForgotPasswordMessage("");
       setForgotPasswordError("");
     }
   };

   // Email validation function
   const isValidEmail = (email) => {
     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
     return emailRegex.test(email);
   };

   const handleBackToLogin = () => {
     setShowForgotPassword(false);
     setForgotPasswordData({ email: "" });
     setForgotPasswordMessage("");
     setForgotPasswordError("");
   };



	return (
		<>
		<Header />
		<div className="login-register">
			{isloader &&
		<div className="loader position-fixed top-0 bottom-0 start-0 end-0 bg-dark">
		<span className="position-absolute top-50 start-50 translate-middle"><img src={Loader} alt="Loader"  /></span>
		</div>
		}
			<div className="container d-flex align-items-center mvh-100">
			{/* <Link className="back-btn mr-3 " to="/"><i className="fa fa-arrow-left" aria-hidden="true"></i></Link> */}

			<section className="login-registration rounded-3 overflow-hidden shadow bg-light">
				
				<div className="row align-items-stretch">

				<div className="col-md-6 bg-secondary-s text-center text-white">

					<div className="p-5">

					<h1 className="h3">{showForgotPassword ? "Reset Your Password" : "Let's Get Started"}</h1>
					<p>
						{showForgotPassword 
							? "Forgot your password? No problem. We'll send you an email to reset your password and enter a new one."
							: "Login to continue to Florida Driving Permit"
						}
						<br></br>
						{errors.apiError && <span className="text-danger">{errors.apiError}</span>}<br></br>
						{successMessage && <span className="text-success">{successMessage}</span>}
					</p>
					{!showForgotPassword ? (
						<form className="text-dark py-4" onSubmit={handleSubmit}>
							<div className="row">
								<div className="col-lg-6">
									<div className="form-floating mt-4">
									<input type="email" className="form-control" id="email" name="email"  autoComplete="email" value={formData.email} onChange={handleChange}  placeholder=" " />
									<label htmlFor="email">Email</label>
									{errors.email && <span className="text-danger">{errors.email}</span>}
									</div>
								</div>
								<div className="col-lg-6">
									<div className="form-floating mt-4">
									<input type="password" className="form-control" id="password" name="password" value={formData.password} onChange={handleChange}  placeholder=" " autoComplete="current-password"  />
									<label htmlFor="password">Password</label>
									{errors.password && <span className="text-danger">{errors.password}</span>}
									</div>
								</div>
								<div className="col-12">
									<button 
										name="btn" 
										className="btn btn-primary-s px-4 py-3 my-4 w-100 text-white"
										disabled={isSubmitting}
									>
										{isSubmitting ? (
											<>
												<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
												Processing...
											</>
										) : (
											'LOGIN'
										)}
									</button>
									<p className="text-white">OR<br /></p>
								</div>
								{/* <div className="col-lg-12 mt-3">
									<GoogleLogin className="btn btn-danger px-4 py-2 my-4 w-100" onSuccess={responseMessage} onError={errorMessage} />
								</div> */}
								
								<div className="col-12 mt-3">
									<p className="text-white">Don't have an account ? <Link to="/register" className="text-primary-s fw-bold">REGISTER</Link></p>
									<p className="text-white mt-2">Forgot your password? <button type="button" className="text-primary-s fw-bold btn btn-link p-0" onClick={() => setShowForgotPassword(true)}>RESET PASSWORD</button></p>
								</div>
							</div>
						</form>
					) : (
						<form className="text-dark py-4" onSubmit={handleForgotPassword}>
							<div className="row">
								{/* Back Button */}
								<div className="col-12 mb-3">
									<button 
										type="button" 
										className="btn btn-outline-light btn-sm"
										onClick={handleBackToLogin}
									>
										<i className="fa fa-arrow-left me-2"></i>Back to Login
									</button>
								</div>

								{/* Success Message */}
								{forgotPasswordMessage && (
									<div className="col-12">
										<div className="alert alert-success" role="alert">
											<i className="fa fa-check-circle me-2"></i>
											{forgotPasswordMessage}
										</div>
									</div>
								)}

								{/* Error Message */}
								{forgotPasswordError && (
									<div className="col-12">
										<div className="alert alert-danger" role="alert">
											<i className="fa fa-exclamation-circle me-2"></i>
											{forgotPasswordError}
										</div>
									</div>
								)}

								<div className="col-lg-12">
									<div className="form-floating mt-4">
									<input
										type="email"
										className={`form-control ${forgotPasswordData.email && !isValidEmail(forgotPasswordData.email) ? 'is-invalid' : ''}`}
										id="email2"
										name="email"
										placeholder=" "
										value={forgotPasswordData.email}
										onChange={handleForgotPasswordInputChange}
										required
										disabled={forgotPasswordLoading}
									/>
									<label htmlFor="email2">Enter Your Email</label>
									{forgotPasswordData.email && !isValidEmail(forgotPasswordData.email) && (
										<div className="invalid-feedback text-danger">
											Please enter a valid email address
										</div>
									)}
									</div>
								</div>
								<div className="col-12">
									<button
										type="submit"
										className="btn btn-primary-s px-4 py-3 my-4 w-100 text-white"
										disabled={forgotPasswordLoading || !forgotPasswordData.email.trim() || !isValidEmail(forgotPasswordData.email)}
									>
										{forgotPasswordLoading ? (
											<>
												<i className="fa fa-spinner fa-spin me-1"></i> Sending...
											</>
										) : (
											<>
												<i className="fa fa-lock me-1"></i> Reset Password
											</>
										)}
									</button>
								</div>
							</div>
						</form>
					)}
					</div>
				</div>
				<div className="col-md-6 text-center d-none d-md-block">
					<div className="p-5">
						<Link to="/" className="mb-2 mt-4 wow animated fadeInLeft hide-mobile logoText">
							<h3>Florida <span>Driving</span> Permit</h3>
						</Link>
						<br /><br />
						<hr className="opacity-50" />
						<img src={imageAside} alt="Form Aside" className="img-fluid mt-5 w-85" />
					</div>
				</div>
				</div>
			</section>
			</div>
		</div>
		</>
		
	);
}
export default Login;